import { render, staticRenderFns } from "./DetectionListLink.vue?vue&type=template&id=6cb81219&scoped=true"
import script from "./DetectionListLink.vue?vue&type=script&lang=js"
export * from "./DetectionListLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb81219",
  null
  
)

export default component.exports